import { StatusPill } from '@/components/administration/kpi-metrics/shared/status-pill'
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from '@/components/ui/table'
import type { PersonTimelineInteracao } from '@/types'
import { formatDateToDisplay } from '@/utils/formatDate'
import { TimelineEmptyState } from '../person-timeline-modal'
import { CollapsibleCountTable } from './collapsible-count-table'

const ACTION_LABEL: Record<string, string> = {
	CONGRATULATED: 'Elogiado',
	ORIENTED: 'Orientado',
}

export function InteracaoTimelineSection({
	data,
}: {
	data: PersonTimelineInteracao
}) {
	const actionEntries = (Object.entries(data.byAction) as [string, number][])
		.filter(([, count]) => !!count)
		.map(([action, count]) => ({
			id: action,
			name: ACTION_LABEL[action] ?? action,
			count,
		}))

	return (
		<div className="flex flex-col gap-4">
			<div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
				<CollapsibleCountTable
					title="Por ação"
					columnLabel="Ação"
					items={actionEntries}
				/>
				<CollapsibleCountTable
					title="Por classificação"
					columnLabel="Classificação"
					items={data.byClassification}
				/>
			</div>

			{data.items.length === 0 ? (
				<TimelineEmptyState label="Nenhuma interação registrada no período." />
			) : (
				<div className="rounded-lg border border-kaefer-light-silver">
					<Table className="table-fixed">
						<TableHeader>
							<TableRow className="bg-muted/30">
								<TableHead className="w-24">Data</TableHead>
								<TableHead className="w-40">Classificação</TableHead>
								<TableHead className="w-28">Ação</TableHead>
								<TableHead>Descrição</TableHead>
							</TableRow>
						</TableHeader>
						<TableBody>
							{data.items.map((item) => (
								<TableRow key={item.id}>
									<TableCell className="whitespace-nowrap text-muted-foreground">
										{formatDateToDisplay(item.date)}
									</TableCell>
									<TableCell className="whitespace-normal wrap-break-word">
										{item.classificationName}
										<p className="text-xs text-muted-foreground">
											{item.subclassificationName}
										</p>
									</TableCell>
									<TableCell>
										<StatusPill status={item.action} />
									</TableCell>
									<TableCell className="whitespace-normal wrap-break-word text-muted-foreground">
										{item.description}
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</div>
			)}
		</div>
	)
}
